import { render, staticRenderFns } from "./CaregiverReports.vue?vue&type=template&id=e917743a&"
import script from "./CaregiverReports.vue?vue&type=script&lang=js&"
export * from "./CaregiverReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports